import React from 'react';
import { setHtml } from '../lib/setHtml';
import { cn } from '@av/utils';

const RichContent = ({ content, className }: { content: string; className?: string }) => {
  return <div {...setHtml(content)} className={cn('rich-html', className)} />;
};

export default RichContent;
